import { render, staticRenderFns } from "./wjx_list.vue?vue&type=template&id=c9f2b426&scoped=true"
import script from "./wjx_list.vue?vue&type=script&lang=js"
export * from "./wjx_list.vue?vue&type=script&lang=js"
import style0 from "./wjx_list.vue?vue&type=style&index=0&id=c9f2b426&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f2b426",
  null
  
)

export default component.exports